import { useState , useEffect } from 'react';
import { useHistory } from 'react-router';
import { Formik } from 'formik';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container'
import successIcon from 'assets/img/verifica.png';   //  lalo edicion de imagen
// eslint-disable-next-line no-unused-vars
import { Modal, ResponseModal, TextArea, Input } from 'components';
import { saveThanksMessage } from 'services/api/table';
import { hideLoader, showLoader } from 'store/actions/commons';
import { useStore } from 'store';
import cartaCorazon from 'assets/img/cartacorazon.png';
import agradecimiento from 'assets/img/agradecimiento.png';
import agradecimientoTextareaMobile from 'assets/img/agradecimiento-textarea-mobile.png';
// eslint-disable-next-line no-unused-vars
import { Table, Button } from 'react-bootstrap';
import { initialValues, schema } from './config';
import './styles.scss';
import BarMobile from 'pages/Header/Content/components/BarMobile';
import { useWindowSize } from 'hooks';
import imageHeader from 'assets/img/planquiero.png'


export default function ThanksMessageHome({ tableId, orderId, whoGaveTheGift, orderDetail, show, onClose = () => { } }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);
  const [showConfirmationMessageError, setShowConfirmationMessageError] = useState(false);
  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  const [, { isMobile }] = useWindowSize()
  const history = useHistory();
  const handleClose = () => {
    onClose(currentStep);
    setCurrentStep(1);
  };

  const handleSubmit = (e) => {
    if (+tableId && +orderId) {
      dispatch(showLoader());
      const payload = {
        gift_table_id: tableId,
        thanks_messaage: e.motive,
        greeting: e.saludo,
        signature: e.firma
      }

      // console.log('payload', payload);        //    ELIMINAR
      //  SERVICIO ENVIO AGRADECIMIENTO
      saveThanksMessage(orderId, payload)
        .then((response) => {
          setShowConfirmationMessage(true);
        })
        .catch((error) => {
          // setShowConfirmationMessageError(true);
          setShowConfirmationMessage(true);
          console.log('ConfirmationMessage ERROR:', error);
        })
        .finally(() => {
          dispatch(hideLoader());
        });
    }
  };

  const handleConfirmationClose = () => {
    setShowConfirmationMessage(false);
    onClose(currentStep);
    setCurrentStep(1);
    if(isMobile){
      // history.push(`/regalos-recibidos/${orderId}/detailsv2`)
      history.goBack();
      // window.location.href = `/Mesa-de-Regalos/regalos-recibidos/${orderId}/detailsv2`;
    }
    else {
      history.push(`/regalos-recibidos/`)
      // window.location.reload();
    }
  };

  const handleConfirmationErrorClose = () => {
    setShowConfirmationMessageError(false);
    onClose(currentStep);
    setCurrentStep(1);
  };


  const [inputSaludo, setinputSaludo] = useState('');
  const [inputMotive, setinputMotive] = useState('');
  const [inputFirma, setinputFirma] = useState('');

  const handleChangeSaludo = (event) => {
    setinputSaludo(event.target.value);
  };

  const handleChangeMotive = (event) => {
    setinputMotive(event.target.value);
  };

  const handleChangeFirmae = (event) => {
    setinputFirma(event.target.value);
  };

  useEffect(() => {
    console.clear();
    console.log('orderDetail', orderDetail);
  }, [])

  return (
    <>
      <BarMobile pageName='Agradecer regalo' marginBottom='32px' />
      <div className="text-center">
        <h2 hidden={isMobile}>
          <img src={cartaCorazon} alt="Carta y corazón" className="img-fluid" /> Agradecimientos
          <hr width="60%" />
        </h2>
        {
          isMobile ? (
            <p className='text-left ml-3'>Escribe un mensaje de agradecimiento a <b>{whoGaveTheGift}</b></p>
          ) : (
            <p>Escribe un mensaje de agradecimiento a <b>{whoGaveTheGift}</b>. El agradecimiento se hará vía correo electrónico.</p>
          )
        }
      </div>

      <ResponseModal
        title="¡Tu agradecimiento se envió con éxito!"
        icon={successIcon}
        show={showConfirmationMessage}
        onClose={handleConfirmationClose}
        onSubmit={handleConfirmationClose}
        codeClassName="text-danger text-center my-4"
        className="ResponseModal__content"
        submitLabel="Entendido"
      />

      <ResponseModal
        title="No se logro enviar el agradecimiento. Intente nuevamente."
        // icon={successIcon}
        show={showConfirmationMessageError}
        onClose={handleConfirmationErrorClose}
        onSubmit={handleConfirmationErrorClose}
        codeClassName="text-danger text-center my-4"
        className="ResponseModal__content"
      />

      <Container>
        {
          isMobile ? (
            <Formik
              initialValues={initialValues}
              validationSchema={schema}
              onSubmit={handleSubmit}
            >
              {(formik) => {
                const { handleSubmit } = formik;
                return (
                  <div>
                    <div className='inputs-container-card'>
                        <img src={imageHeader} className='image'/>
                        <Input name="saludo" placeholder='Saludo' onChange={handleChangeSaludo} className="input-greetings" />
                        <div style={{
                              backgroundImage: `url(${agradecimientoTextareaMobile})`,
                              backgroundSize: 'cover',
                              width: '100%',
                              height: '100%',
                              position: 'relative',
                              top: '3px',
                              left: '1px',
                              zIndex: '1',
                              backgroundPositionX: '10px'
                            }}>
                          <TextArea name="motive" onChange={handleChangeMotive} className="input-greetings textarea textarea-greetings" rows={5} placeholder='Escribe tu agradecimiento aquí'/>
                        </div>                        
                        <Input name="firma" onChange={handleChangeFirmae} className="input-greetings last-input" placeholder='Firma'/>
                    </div>
                    <div className='button-container-form-mobile'>
                      <Button type="submit" onClick={handleSubmit} className='button-form-mobile'>
                        Enviar
                      </Button>
                    </div>
                  </div>
                );
              }}
            </Formik>
          ) : (
            <>
              <Row className="mt-4" />
              <Row>
                <Col lg={6} className="my-5">

                  <Formik
                    initialValues={initialValues}
                    validationSchema={schema}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => {
                      const { handleSubmit } = formik;
                      return (
                        <Col>
                          <div className="form-group">
                            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                            <label className="labels">Saludo:</label>
                            <Input name="saludo" onChange={handleChangeSaludo} className="inputBorder" />
                          </div>
                          <div className="form-group">
                            <label className="labels">Mensaje:</label>
                            <TextArea name="motive" onChange={handleChangeMotive} className="inputBorder  messageAgradecimiento" maxLength={300} />
                          </div>
                          <div className="form-group">
                            <label className="labels">Firma:</label>
                            <Input name="firma" onChange={handleChangeFirmae} className="inputBorder" />
                          </div>
                          <div className="mt-3 text-center">
                            <Button type="submit" onClick={handleSubmit}>
                              Enviar agradecimiento
                            </Button>
                          </div>
                        </Col>
                      );
                    }}
                  </Formik>

                </Col>

                <Col lg={6} className="d-flex align-items-center justify-content-center">
                  <img src={agradecimiento} alt="" className="img-fluid" />
                  <div className="values-container">
                    <Row className="saludo">
                      <Col>
                        <p className="value value-top">{inputSaludo}</p>
                      </Col>
                    </Row>
                    <Row className="mensaje">
                      <Col>
                        <p className="value value-center">{inputMotive}</p>
                      </Col>
                    </Row>
                    <Row className="firma">
                      <Col>
                        <p className="value value-bottom">{inputFirma}</p>
                      </Col>
                    </Row>
                  </div>
                </Col>
                
              </Row>
              <Row className="mb-4 my-4" />
            </>
          )
        }
      </Container>
    </>
  );
}
